<template>
  <div style="background-color: #fdfdfd">
    <Header :isHome="false"></Header>

    <div class="top-bg" style="padding-top: 7rem">
      <!-- <div class="title-box">
				<img src="../../assets/imgs/export-title-icon.png" class="title-icon">
				<span class="title-text">Supplier</span>
			</div>
			<div style="" class="search-box" @keydown.enter="tosearchmain(5)">
				<input type="text" style="border: none;background-color: transparent;color: #000;font-size: 1rem;width: 100%;" v-model="searchkeyword" placeholder="Search">
				<img src="../../assets/imgs/search-dark.png" style="width: 1rem;height: 1rem;cursor: pointer;" @click="tosearchmain(5)">
			</div> -->

      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        class="container top"
      >
        <div style="display: flex; flex-direction: column">
          <div style="" class="top-title">
            <div>
              Globalcare-Info Tissue and Hygiene Industry Demands Publishing
              Platform
            </div>
            <!-- <div>
						</div> -->
          </div>

          <!-- <div style="color: #9DACEE;font-size: 0.9rem;margin-bottom: 1.5rem;" v-if="!isMobile">
						One click release of requirements to quickly find solutions
					</div> -->

          <div style="display: flex; align-items: center" class="top1">
            <div
              class="btn-gold-liner"
              style="
                cursor: pointer;
                padding: 0.7rem 2rem;
                font-size: 1.2rem;
                margin-right: 2rem;
                font-weight: 500;
                border-radius: 10rem;
              "
              @click="publishboxshow()"
            >
              Publish Now
            </div>
            <div style="display: flex; flex-direction: column" class="top2">
              <div
                style="font-size: 0.9rem; margin-bottom: 0rem; color: #9dacee"
              >
                Cumulative demands published
              </div>
              <div style="font-size: 1.2rem; font-weight: bold; color: #fff">
                {{ total }}
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative" v-if="!isMobile">
          <!-- 右侧滚动 -->
          <!-- 
					<div class="col-lg-6 col-md-8 mb-30 wow fadeInUp animated solution-r" data-wow-delay="0.2" style="height: 44rem;">
						<div style="position: relative;">
							<div style="background-color: #62e0c9;height: 35rem;position: absolute;left: 1rem;top:5rem;border-radius: 1.875rem;" class="box-border"></div> -->
          <div
            style="
              background-color: #fff;
              height: 18rem;
              border: 0.1rem solid #000;
              border-radius: 1rem;
            "
            class="box-border"
          >
            <div style="padding: 1.5rem 1.5rem 1rem; height: 100%">
              <div class="req-box">
                <vue-seamless-scroll
                  :data="topdata"
                  :class-option="optionHover"
                >
                  <div
                    style="display: flex; flex-direction: column"
                    v-for="(item, index) in topdata"
                    :key="index"
                  >
                    <div style="display: flex">
                      <span
                        style="font-size: 1rem; font-weight: bold; flex: 1"
                        >{{ item.user.username }}</span
                      >
                      <!-- <img :src="require('../../assets/img/uneed/'+index.jpg)" alt="" style="width: 1.875rem;height: 1.875rem;border-radius: 50%;"> -->
                      <div
                        :style="{
                          backgroundImage: 'url(' + item.user.avatar + ')',
                        }"
                        style="
                          width: 1.875rem;
                          height: 1.875rem;
                          border-radius: 50%;
                          background-position: center;
                          background-repeat: no-repeat;
                          background-size: cover;
                        "
                      ></div>
                    </div>
                    <div
                      style="
                        display: flex;
                        padding: 0.5rem 0;
                        border-bottom: 1px solid #e1e1e1;
                        margin-bottom: 1rem;
                      "
                    >
                      <img
                        src="../../assets/imgs/requirements-box-left.png"
                        alt=""
                        style="width: 0.2rem"
                      />
                      <div
                        style="
                          font-size: 0.8rem;
                          font-weight: 400;
                          margin-left: 1rem;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        class="req-text"
                      >
                        {{ item.content }}
                      </div>
                    </div>
                  </div>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
          <div
            style="
              position: absolute;
              left: 3rem;
              top: -1rem;
              padding: 0.5rem 1rem;
              background-color: #fedf34;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.8rem;
              font-weight: bold;
              rotate: 355deg;
            "
          >
            Lastest Insights
          </div>
          <!-- </div>
					</div> -->
        </div>
      </div>
    </div>
    <div
      v-show="sidebox"
      style="
        position: fixed;
        right: 0;
        bottom: 0;
        height: 100vh;
        z-index: 5;
        background-color: rgba(0, 0, 0, 0.55);
        width: 100vw;
      "
      @click="sidebox = !sidebox"
    ></div>
    <div class="container" v-if="data" style="">
      <div
        class="row main-box"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: 15px;
          padding-right: 15px;
          flex-direction: row;
        "
      >
        <div style="font-size: 1rem; color: #000; font-weight: 500">
          <span
            class="hover-light"
            style="cursor: pointer; margin-right: 0.5rem"
            @click="tohome()"
            >Home</span
          >>
          <span style="margin-left: 0.5rem">Project Sourcing</span>
        </div>

        <!-- 移动端筛选 -->
        <div v-if="isMobile" style="width: 100%">
          <div
            style="
              display: flex;
              flex-wrap: nowrap;
              width: 100%;
              overflow: scroll;
              margin-bottom: 0rem;
              margin-top: 1rem;
            "
            class="noscrollbar"
            ref="wrapper"
          >
            <div
              v-for="(item, index) in sidedata"
              :key="index"
              style="cursor: pointer"
            >
              <div
                class="btn-normal"
                :class="{ 'btn-normal-active': cid == item.id }"
                style="cursor: pointer; width: max-content"
                @click="checksidedata(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>

        <!-- 搜索框 -->
        <div class="box1">
          <div style="" class="search-box" @keydown.enter="getdata()">
            <input
              type="text"
              style="
                border: none;
                background-color: transparent;
                color: #000;
                font-size: 1rem;
                width: 100%;
              "
              v-model="searchkeyword"
              placeholder="Search"
            />
            <img
              src="../../assets/imgs/search-dark.png"
              style="width: 1rem; height: 1rem; cursor: pointer"
              @click="getdata()"
            />
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: rem; justify-content: space-between">
        <div
          class="col-3 side-box transition-normal"
          :style="{ maxWidth: sidebox || !isMobile ? '20rem' : '4.1rem' }"
          v-if="!isMobile"
        >
          <!-- <div class=""> -->
          <div class="side-title" v-if="!isMobile">
            <span style="flex: 1">Filter By</span>
            <img
              src="../../assets/imgs/arrow-down-black.png"
              class="transition-normal"
              style="width: 1rem; height: 0.5rem; cursor: pointer"
              :style="{ transform: filtershow ? 'rotate(180deg)' : 'none' }"
              @click="filtershow = !filtershow"
            />
          </div>
          <div class="side-title" v-else>
            <span style="flex: 1">
              <img
                :src="
                  sidebox
                    ? require('../../assets/imgs/mobile-side-icon.svg')
                    : require('../../assets/imgs/mobile-side-icon-before.svg')
                "
                style="width: 2rem; height: 2rem; cursor: pointer"
                @click="sidebox = !sidebox"
              />
            </span>
            <!-- <img src="../../assets/imgs/arrow-down-black.png" style="width: 1rem;height: 0.5rem;"> -->
          </div>
          <div
            class="side-content transition-normal"
            v-if="sidebox || !isMobile"
            :style="{
              height: filtershow ? sidedata.length * 2.4 + 'rem' : '0rem',
            }"
            style="overflow: scroll"
          >
            <!-- <div style="display: flex;margin-bottom: 1rem;align-items: center;margin:1rem 1rem 0.5rem">
								<div style="width: 1rem;height: 1rem;border: 1px solid #666;margin-right: 1rem;"
										:style="{backgroundColor: isall?'#00C2A0':'transparent'}"@click="checkall()"></div>All supplier
							</div> -->
            <div
              style="
                display: flex;
                margin-bottom: 1rem;
                align-items: center;
                margin: 0.5rem 1rem;
              "
              v-for="(item, index) in sidedata"
              :key="index"
              @click="checksidedata(item)"
            >
              <div
                style="
                  width: 1rem;
                  height: 1rem;
                  border: 1px solid #666;
                  margin-right: 1rem;
                "
                :style="{
                  backgroundColor: cid == item.id ? '#00C2A0' : 'transparent',
                }"
              ></div>
              {{ item.title }}
            </div>
            <!-- <div style="display: flex;margin-bottom: 1rem;align-items: center;margin:0.5rem 1rem">
								<div style="width: 1rem;height: 1rem;border: 1px solid #666;margin-right: 1rem;"
										:style="{backgroundColor: website?'#00C2A0':'transparent'}"@click="changewebsite"></div>Website
							</div> -->
          </div>
          <!-- </div> -->
        </div>
        <div class="col-9 main-box">
          <!-- <div class="r-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">ISO9000</span>
					</div> -->
          <!-- <div style="display: flex;flex-wrap: wrap;margin-bottom: 1rem;">
						<div v-for="(item, cidsindex) in cidslist" :key="cidsindex" style="margin-right: 0.5rem;margin-bottom: 0.5rem;padding: 0.4rem 0.7rem;" class="btn-normal">
							<span style="margin-right: 0.5rem;" v-text="item.name"></span><img src="../../assets/imgs/close-tag.png" style="width:q 1.2rem;height: 1.2rem;cursor: pointer;" @click="closetag(item)">
						</div>
					</div> -->

          <div
            class="hover-up transition-normal fadeIn animated supplier-box"
            style="
              background-color: #fff;
              padding: 2rem;
              display: flex;
              margin-bottom: 2rem;
              border-radius: 1rem;
              cursor: pointer;
            "
            v-for="(item, index2) in data"
            :key="index2"
            @click="todemanddetail(item)"
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                width: 100%;
                position: relative;
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 1rem"
              >
                <div
                  :style="{ backgroundImage: 'url(' + item.user.avatar + ')' }"
                  style=""
                  class="main-img"
                ></div>
                <div
                  style=""
                  class="main-title"
                  v-text="item.user.username"
                ></div>
              </div>
              <!-- <div style="display: flex;flex-wrap: wrap;cursor: pointer;" @click="tosupplierdetail(item)">
								<div v-for="(c, index3) in item.certifications" :key="index3" style="padding:0rem 0.5rem;border: 1px solid #D8D8D8;border-radius: 2rem;font-size: 0.5rem;
								display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.5rem;" v-text="c.name"></div>
							</div> -->
              <div
                style="font-size: 1rem; color: #000; margin-bottom: 1rem"
                class="supplier-desc"
                v-text="item.content"
              ></div>
              <!-- <div style="display: flex;justify-content: flex-end;margin-top: 1rem;" v-if="!isMobile">
								<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
										font-weight: bold;width: 6rem;cursor: pointer;position: absolute;right: 0;bottom: 0;"
										:class="{'btn-cyan':!item.follow, 'btn-lightgreen':item.follow}" @click="changefollow(item)" v-text="item.follow?'UnFollow':'Follow'"></div>
							</div> -->
              <div style="font-size: 0.8rem; color: #666; margin-bottom: 1rem">
                # {{ item.classify.title }}
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>Deadline: {{ item.expireTime | formatDate }}</div>
                <div
                  class="btn-cyan-liner"
                  style="
                    padding: 0.4rem 1rem;
                    border-radius: 5rem;
                    cursor: pointer;
                    font-size: 0.8rem;
                    font-weight: 500;
                  "
                >
                  more
                </div>
              </div>
            </div>
          </div>

          <pagination
            :page="page"
            :page-size="perPage"
            :total="nowtotal || 0"
            :on-page-change="onPage"
            :pageSizeList="[]"
            class="pagi page-content"
          />
        </div>
      </div>
    </div>

    <!-- 发布需求组件 -->
    <Demandpulish></Demandpulish>

    <Footer style="margin-top: 3rem"></Footer>
  </div>
</template>

<script>
// import axios from 'axios'
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";
// import {baseUrl} from '../../assets/js/public.js'

import Pagination from "@/components/pagination.vue";
import Demandpulish from "/src/components/demand/demandpulish.vue";

export default {
  data() {
    return {
      topdata: [],
      sidedata: [],
      // cidslist:[],
      cid: "",
      filtershow: true,

      data: [],
      page: 1,
      perPage: 6,

      sidebox: false,
      isMobile: false,
      islogin: false,
      searchkeyword: "",

      total: 0,
      nowtotal: 0,
      //   isuserlevel: false,
      //   默认全部都是会员
      isuserlevel: true,
    };
  },
  props: {},
  filters: {
    formatDate: function (timestemp) {
      let date = new Date(timestemp * 1000);
      return (
        date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
      );
    },
  },
  components: {
    Header,
    Footer,
    Pagination,
    Demandpulish,
  },
  computed: {
    optionHover() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    tosearchmain(type) {
      this.$router.push({
        name: "searchmain",
        query: { type: type, keyword: this.searchkeyword },
      });
    },
    // 分页
    onPage(pageNow) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        // console.log('pageNow', pageNow);
        this.page = pageNow;
        window.scrollTo(0, 0);
        this.getdata();
      }
    },
    todemanddetail(item) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        this.$router.push({ name: "demanddetail", query: { id: item.id } });
      }
    },
    checksidedata(item) {
      // if(this.cidslist.includes(item)){
      // 	for (let i in this.cidslist) {
      // 		if(this.cidslist[i].id == item.id){
      // 			this.cidslist.splice(i,1)
      // 		}
      // 	}
      // }else{
      // 	this.cidslist.push(item)
      // }

      // 未登录
      // if(!this.islogin){
      // 	// 判断移动端
      // 	if(this.isMobile){
      // 		this.$router.push({name:'mlogin',query:{type:1}})
      // 	}else{
      // 		localStorage.setItem('logintype', 1)
      // 		this.$bus.$emit("login", true);
      // 	}
      // 	// 判断是否是会员
      // }else if(!this.isuserlevel){
      // 	// this.$router.push('userlevel')
      // 	this.$bus.$emit('userleveldialog', true)
      // }else{
      this.cid == item.id ? (this.cid = "") : (this.cid = item.id);
      this.page = 1;
      window.scrollTo(0, 0);
      this.getdata();
      // }
    },
    changefollow(item) {
      let params = {
        providerId: item.id,
      };
      this.request({
        method: "post",
        url: "/gci/user/provider/follow",
        data: params,
      })
        .then((res) => {
          this.getdata();
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getdata() {
      // let cids = ''
      // for (let i in this.cidslist) {
      // 	cids += this.cidslist[i].id + ','
      // }
      // cids = cids.slice(0, -1)
      // console.info(cids)
      this.request({
        method: "get",
        url:
          "/gci/demand/list?classifyId=" +
          this.cid +
          "&page=" +
          this.page +
          "&perPage=" +
          this.perPage +
          "&keyword=" +
          this.searchkeyword,
      })
        .then((res) => {
          this.data = res.data.items;
          // console.info(this.cid)
          // if(this.cid == ''){
          // 	this.total = res.data.total
          // }
          this.nowtotal = res.data.total;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getalldata() {
      this.request({
        method: "get",
        url:
          "/gci/demand/list?classifyId=" +
          "&page=" +
          this.page +
          "&perPage=" +
          this.perPage +
          "&keyword=",
      })
        .then((res) => {
          this.total = res.data.total;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getdatabyistop() {
      this.request({
        method: "get",
        url: "/gci/demand/list?isTop=true",
      })
        .then((res) => {
          this.topdata = res.data.items;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getsidedata() {
      this.request({
        method: "get",
        url: "/gci/demand/classify",
      })
        .then((res) => {
          this.sidedata = res.data.items;
          this.$bus.$emit("loading", false);
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    tohome() {
      this.$router.push({ name: "home" });
    },
    publishboxshow() {
      // // 是否登录
      // if(this.islogin){
      // 	// this.publishbox = true
      // 	this.$bus.$emit('publishbox', {show:true,type:1})
      // }else{
      // 	// 是否移动端
      // 	if(this.isMobile){
      // 		this.$router.push({name:'mlogin', query:{type:0}})
      // 	}else{
      // 		this.$bus.$emit('login', true)
      // 	}
      // }

      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        this.$bus.$emit("publishbox", { show: true, type: 1 });
      }
    },
  },
  created() {
    this.$bus.$emit("loading", true);
  },
  mounted() {
    localStorage.getItem("isMobile") == "null"
      ? (this.isMobile = false)
      : (this.isMobile = true);
    if (localStorage.getItem("token")) {
      this.islogin = true;
      let userinfo = JSON.parse(localStorage.getItem("user"));
      if (userinfo.vip.id != 1) {
        this.isuserlevel = true;
      }
    }
    this.getalldata();
    // 导航跳转
    if (this.$route.query.id) {
      this.cid = this.$route.query.id;
    }
    this.getsidedata();
    this.getdata();
    this.getdatabyistop();
  },
};
</script>

<style scoped lang="scss">
.top-title {
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 2.2rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}
.main-img {
  min-width: 2.5rem;
  height: 2.5rem;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  margin-right: 0.5rem;
}
.req-box {
  // padding: 3rem 2rem 2rem;
  overflow: hidden;
  height: 100%;
}
.r-title {
  height: 3rem;
  font-size: 1.5rem;
  font-weight: bold;
  position: relative;
  .r-title-bg {
    width: 13rem;
    position: absolute;
    left: -0.5rem;
    top: -2rem;
  }
}
.side-box {
  background-color: #fff;
  border-radius: 1rem;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  padding: 0;
  height: 100%;

  .side-title {
    color: #000;
    padding: 1rem;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
  }
  .side-content {
    display: flex;
    flex-direction: column;
    // padding: 1rem;
  }
}
.side-content::-webkit-scrollbar {
  display: none;
}
.main-box {
  display: flex;
  flex-direction: column;
  padding-left: 2rem;
}
.title-text {
  margin-left: -2rem;
}
.title-box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  color: #333;
  font-size: 3rem;
}
.title-icon {
  width: 3rem;
  height: 3rem;
  margin-top: 1rem;
}
.top-bg {
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../assets/imgs/demand/bg.jpg");
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  flex-direction: column;
}
.search-box {
  width: 20rem;
  height: 2.5rem;
  background-color: #fff;
  margin-top: 1rem;
  border-radius: 5rem;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  border: 1px solid #ececec;
}
.main-title {
  color: #000;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.supplier-desc {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
.box-border {
  width: 25rem;
}
@media (max-width: 767px) {
  .box-border {
    width: 19rem;
  }
  .side-box {
    position: fixed;
    left: 0;
    top: 4rem;
    z-index: 9;
    height: 100%;
    border-radius: 0;
    padding-top: 5rem;
  }
  .top-bg {
    padding-top: 7rem !important;
    // position:fixed;z-index:10;left:0;top:0;
    .search-box {
      display: none;
    }
  }
  .top {
    flex-direction: column;
    align-items: flex-start;
  }
  .top-title {
    font-size: 1.5rem;
  }
  .top1 {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .top2 {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
  .main-box {
    padding: 0.5rem !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    // padding-left: 0 !important;
  }
  .search-box {
    width: 100%;
  }
  .col-9 {
    max-width: 100%;
    min-width: 100%;
  }
  .main-img {
    margin-bottom: 1rem;
    margin-right: 1rem;
  }
  .main-title {
    font-size: 1.2rem;
  }
  .supplier-box {
    flex-direction: column;
    // padding:0.5rem !important;
    margin-bottom: 1rem !important;
    justify-content: center;

    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.08);
    width: 100%;
  }
  .title-box {
    font-size: 2.2rem;
  }
  .title-icon {
    margin-top: 0.5rem;
  }
  .row {
    margin-top: 0 !important;
  }
  .box1 {
    width: 100%;
  }
}
@media (min-width: 767px) {
  .main-box {
    margin-bottom: 1rem;
  }
  .top-bg {
    padding-bottom: 3rem;
  }
}
</style>
